import React, { useEffect, useState } from "react";
import { CiFilter } from "react-icons/ci";
import { IoIosArrowBack } from "react-icons/io";
import { IoCheckmark } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { getPatientReportAction } from "../../../Actions/PatientActions/PatientAction";
import { FaFilter } from "react-icons/fa";
import Pagination from "../../Pagination";

const ReportPage = () => {
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const dispatch = useDispatch();
  const getPatientReport = useSelector((state) => state.getPatientReport);
  const { patients, total, loading } = getPatientReport;

  const th = [
    {
      label: "Code",
      name: "code",
    },
    {
      label: "full Name",
      name: "fullname",
    },
    {
      label: "Gender",
      name: "gender",
    },
    {
      label: "phone",
      name: "phone",
    },
    {
      label: "birth date",
      name: "birthDate",
    },
  ];
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [indexx, setIndexx] = useState(null);
  const [filter, setFilter] = useState({
    fullname: "",
    code: "",
    gender: "",
    phone: "",
    birthDate: "",
    from: "",
    to: "",
    reject: "",
  });
  useEffect(() => {
    dispatch(
      getPatientReportAction(
        
        page,
        perPage,
        filter.fullname,

        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        filter.from,
        filter.to,
        filter.reject,
      )
    );
  }, [perPage, filter.reject]);
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };
  const handleSearch = () => {
    dispatch(
      getPatientReportAction(
        0,
        perPage,
        filter.fullname,
        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        filter.from,
        filter.to,
        filter.reject
      )
    );
    setIndexx(null);
  };
  const handleClearSearch = (name) => {
    const updateFilter = { ...filter };
    updateFilter[name] = "";

    dispatch(
      getPatientReportAction(
        0,
        perPage,
        updateFilter.fullname,
        updateFilter.code,
        updateFilter.gender,
        updateFilter.phone,
        updateFilter.birthDate,
        updateFilter.from,
        updateFilter.to,
        filter.reject
      )
    );
    setIndexx(null);
  };
  const onPageChange = (event) => {
    setPage(event.selected);
    dispatch(
      getPatientReportAction(
        event.selected + 1,

        perPage,
        filter.fullname,
        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        filter.from,
        filter.to,
        filter.reject
      )
    );
  };
  return (
    <div className="parent">
      <div className="flex justify-between items-center px-3">
        <div className="flex gap-2 items-center p-2">
          <div>
            <input
              type="date"
              className="input"
              name="from"
              onChange={handleFilterChange}
              value={filter.from}
            />
          </div>
          <p>to</p>
          <div>
            <input
              type="date"
              className="input"
              name="to"
              onChange={handleFilterChange}
              value={filter.to}
            />
          </div>
          <div>
            <button onClick={handleSearch} className="btn-primary py-2">
              <CiFilter />{" "}
            </button>
          </div>
        </div>

        <div>
          <select
            name="reject"
            className="block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            value={filter.reject}
            onChange={handleFilterChange}
            id=""
          >
            <option value="">Select Reject</option>
            <option value={1}>Yes</option>
            <option value={0}>No</option>
          </select>
        </div>
      </div>
      <div className={"parent-table  w-full"}>
        <div className=" overflow-y-auto" style={{ height: "70vh" }}>
          <table className="w-full  overflow-y-auto">
            <thead className="coustm-thead">
              <tr>
                <th className="coustm-th">#</th>
                {th.map((th, index) => {
                  return (
                    <th className="coustm-th relative " key={index}>
                      <div className="flex justify-between items-center">
                        {th.label}
                        <div
                          className="parent-filter"
                          onClick={() => {
                            setIsOpenFilter(!isOpenFilter);
                            setIndexx(index);
                          }}
                        >
                          <CiFilter />
                        </div>
                      </div>
                      {index == indexx && isOpenFilter && (
                        <div className="parent-input-filter ">
                          <input
                            type="text"
                            className="p-2 text-black"
                            name={th.name}
                            onChange={handleFilterChange}
                            value={filter[th.name]}
                            placeholder={th.label}
                          />
                          <div className="fotter-filter mt-2">
                            <button
                              className="btn-primary px-1.5 py-1 font-bold"
                              onClick={handleSearch}
                            >
                              <IoCheckmark />
                            </button>
                            <button
                              onClick={() => handleClearSearch(th.name)}
                              className="btn-danger px-1.5 py-1"
                            >
                              <RxCross2 />
                            </button>
                          </div>
                        </div>
                      )}
                    </th>
                  );
                })}
                <th className="coustm-th">Visits </th>
                {/* <th className="coustm-th">Action</th> */}
              </tr>
            </thead>

            <tbody>
              {patients?.map((patient, index) => {
                return (
                  <tr
                    className={
                      patient.patient_info.assign == 1
                        ? "coustm-tr bg-indigo-500 bg-opacity-40"
                        : patient.patient_info.assign == 2
                        ? "coustm-tr bg-green-500 bg-opacity-40"
                        : "coustm-tr"
                    }
                    key={index}
                  >
                    <td className="coustm-td">{index + 1}</td>

                    <td className="coustm-td"> {patient.patient_info.code}</td>
                    <td className="coustm-td">
                      {" "}
                      {patient.patient_info.fullname}
                    </td>
                    <td className="coustm-td">
                      {" "}
                      {patient.patient_info.gender}
                    </td>
                    <td className="coustm-td"> {patient.patient_info.phone}</td>
                    <td className="coustm-td">
                      {" "}
                      {patient.patient_info.birth_date}
                    </td>
                    <td
                      // onClick={() => navigate("medicalForm/" + patient.id)}
                      className="coustm-td text-red-600 underline text-lg font-bold text-center"
                    >
                      {" "}
                      {patient.count_visits_with_approve}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      {patients?.length > 0 && (
        <Pagination
          total={total}
          perPage={perPage}
          page={page}
          onPageChange={onPageChange}
          setPerPage={setPerPage}
        />
      )}
    </div>
  );
};

export default ReportPage;
